import * as React from 'react';
import { Row } from 'reactstrap';
import { Svg } from 'src/components/shared/Svg';
import { ICreateStepDto } from 'src/model/dto/step-dto';
import { PropositionStepItemEdition } from './PropositionStepItemEdition';

interface IPropositionStepListEditionProps {
  edit: boolean;
  stepList: ICreateStepDto[];
  handleStepListChange: (stepList: ICreateStepDto[]) => void;
  deleteStep: (stepNumber: number) => void;
}

export const PropositionStepListEdition: React.SFC<
  IPropositionStepListEditionProps
> = ({ deleteStep, edit, handleStepListChange, stepList }) => {
  const handleStepChange = (step: ICreateStepDto, index: number) => {
    const newStepList = stepList;
    newStepList[index] = step;
    handleStepListChange(newStepList);
  };

  const addStep = (stepNumber: number) => {
    const newStepList = stepList;
    if (!stepList.length) {
      newStepList.push({
        stepNumber: 1,
      });
    }
    newStepList.push({
      stepNumber,
    });
    handleStepListChange(newStepList);
  };

  return (
    <>
      <span>Étapes</span>
      {stepList && stepList.length ? (
        stepList.map((step: ICreateStepDto, index: number) => (
          <PropositionStepItemEdition
            key={index}
            edit={edit}
            index={index}
            step={step}
            handleStepChange={handleStepChange}
            deleteStep={deleteStep}
          />
        ))
      ) : (
        <PropositionStepItemEdition
          edit={edit}
          index={0}
          step={{ stepNumber: 1 }}
          handleStepChange={handleStepChange}
          deleteStep={deleteStep}
        />
      )}
      {edit && (
        <Row
          className='mt-4'
          onClick={() => addStep(stepList.length ? stepList.length + 1 : 2)}
          style={{ opacity: 0.5 }}
        >
          <Svg
            width={24}
            fill='dark'
            src='plus'
            style={{ cursor: 'pointer' }}
          />
          <span
            className='text-uppercase text-dark ml-2'
            style={{ cursor: 'pointer' }}
          >
            Ajouter étape
          </span>
        </Row>
      )}
    </>
  );
};



// WEBPACK FOOTER //
// ./src/components/Project/PropositionEdition/PropositionStepListEdition/PropositionStepListEdition.tsx